/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { OrgAdminEnrollUserCourseOptions, OrgAdminEnrollUserCourseResponses } from '../../models/OrgAdminEnrollUserCourse'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Enroll User Course
 * {@link /course/enroll-user}
 */
export function orgAdminEnrollUserCourse<ThrowOnError extends boolean = true>(options: Options<OrgAdminEnrollUserCourseOptions, ThrowOnError>): Promise<UnwrappedResult<OrgAdminEnrollUserCourseResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/course/enroll-user', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<OrgAdminEnrollUserCourseResponses, ThrowOnError>>
}
